import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "lovable:chunk-reloaded";

/**
 * React.lazy that survives stale chunk references after a new deploy.
 * If a dynamic import fails (old hashed filename no longer on the CDN),
 * reload the page once to pick up the new build.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      try {
        if (sessionStorage.getItem(RELOAD_KEY) === "1") {
          return Promise.reject(error);
        }

        sessionStorage.setItem(RELOAD_KEY, "1");
      } catch {
        // Without persistent storage, reloading could create an infinite loop.
        throw error;
      }

      window.location.reload();
      // Never resolves; the page is reloading.
      return new Promise<{ default: T }>(() => {});
    }
  });
}
